/*
 * CasasCAD — lp-reveal.js
 * Activa las animaciones ".reveal" (fade-up al hacer scroll) que estaban en el CSS
 * pero nunca se disparaban (faltaba este JS → todo quedaba en opacity:0).
 *
 * Garantías:
 *  - En el EDITOR de Shopify (design mode) o con "reducir movimiento": muestra todo, sin animar.
 *  - En navegadores sin IntersectionObserver: muestra todo.
 *  - Red de seguridad: cualquier .reveal que quede visible en pantalla se revela igual.
 * El CSS oculta .reveal SOLO cuando <html> tiene la clase .js-reveal (la agrega el snippet
 * lp-reveal.liquid). Si este archivo no carga, el contenido se ve igual.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var isEditor = root.classList.contains('shopify-design-mode');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) { el.classList.add('is-visible'); }

  function revealAll(scope) {
    var nodes = (scope || document).querySelectorAll('.reveal:not(.is-visible)');
    for (var i = 0; i < nodes.length; i++) reveal(nodes[i]);
  }

  // Caso simple: editor, reduce-motion o sin soporte → mostrar todo de inmediato.
  if (isEditor || reduceMotion || !('IntersectionObserver' in window)) {
    revealAll();
    // En el editor, cada vez que Shopify recarga una sección, revelar su contenido.
    document.addEventListener('shopify:section:load', function (e) { revealAll(e.target); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        reveal(entries[i].target);
        io.unobserve(entries[i].target);
      }
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  function observe(scope) {
    var nodes = (scope || document).querySelectorAll('.reveal:not(.is-visible)');
    for (var i = 0; i < nodes.length; i++) io.observe(nodes[i]);
  }

  observe();

  // Contenido inyectado después (editor, secciones dinámicas): observar lo nuevo.
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });

  // Red de seguridad: al terminar de cargar, revelar lo que ya esté en viewport
  // (por si el observer no alcanzó a dispararse en algún caso raro).
  window.addEventListener('load', function () {
    setTimeout(function () {
      var nodes = document.querySelectorAll('.reveal:not(.is-visible)');
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].getBoundingClientRect().top < window.innerHeight) reveal(nodes[i]);
      }
    }, 200);
  });
})();
